var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("b-jumbotron", { attrs: { lead: "Bonjour " + _vm.user.name } }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "b-card-group",
            { attrs: { deck: "" } },
            [
              _c(
                "b-card",
                {
                  attrs: {
                    header: "Création des comptes clients",
                    "header-tag": "header",
                  },
                },
                [
                  _c(
                    "b-card-group",
                    { staticClass: "home-card", attrs: { deck: "" } },
                    [
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized([
                            "admin",
                            "seller",
                            "trainer",
                          ])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: { to: { name: "ContractAdd" }, tag: "b-card" },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box":
                                      _vm.IconNewContract.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "new-contract",
                                  },
                                },
                                [_c("icon-new-contract")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Ajouter un contrat\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized([
                            "admin",
                            "seller",
                            "trainer",
                          ])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: { to: { name: "TagHandler" }, tag: "b-card" },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box":
                                      _vm.IconNewContract.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "new-contract",
                                  },
                                },
                                [_c("icon-new-contract")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Gestion des tags\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                { attrs: { header: "Suivi clients", "header-tag": "header" } },
                [
                  _c(
                    "b-card-group",
                    { staticClass: "home-card", attrs: { deck: "" } },
                    [
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized([
                            "admin",
                            "seller",
                            "trainer",
                          ])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: { to: { name: "Contracts" }, tag: "b-card" },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box":
                                      _vm.IconContractList.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "contract-list",
                                  },
                                },
                                [_c("icon-contract-list")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v("\n              Contrats\n            "),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized([
                            "admin",
                            "seller",
                            "trainer",
                          ])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: {
                            to: { name: "Establishments" },
                            tag: "b-card",
                          },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box":
                                      _vm.IconEstablishment.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "establishment",
                                  },
                                },
                                [_c("icon-establishment")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Etablissements\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized([
                            "admin",
                            "seller",
                            "trainer",
                          ])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: {
                            to: { name: "StatsEstablishments" },
                            tag: "b-card",
                          },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box":
                                      _vm.IconMonitoring.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "monitoring",
                                  },
                                },
                                [_c("icon-monitoring")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Suivi client\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized([
                            "admin",
                            "seller",
                            "trainer",
                          ])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: {
                            to: { name: "Troubleshooting" },
                            tag: "b-card",
                          },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box": _vm.IconHelp.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "help",
                                  },
                                },
                                [_c("icon-help")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v("\n              Dépannage\n            "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c(
            "b-card-group",
            { attrs: { deck: "" } },
            [
              _c(
                "b-card",
                { attrs: { header: "Formation", "header-tag": "header" } },
                [
                  _c(
                    "b-card-group",
                    { staticClass: "home-card", attrs: { deck: "" } },
                    [
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized(["admin", "trainer"])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: {
                            to: { name: "TrainingDocs" },
                            tag: "b-card",
                          },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box": _vm.IconTraining.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "training",
                                  },
                                },
                                [_c("icon-training")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Documents de formation\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                {
                  attrs: {
                    header: "Outils de développement",
                    "header-tag": "header",
                  },
                },
                [
                  _c(
                    "b-card-group",
                    { staticClass: "home-card", attrs: { deck: "" } },
                    [
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized([
                            "admin",
                            "trainer",
                            "product",
                          ])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: { to: { name: "MiniQuiz" }, tag: "b-card" },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box": _vm.IconUpgrade.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "upgrade",
                                  },
                                },
                                [_c("icon-upgrade")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Gestion de la Quizothèque\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized(["admin", "developer"])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: { to: { name: "Musique" }, tag: "b-card" },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box": _vm.IconMusic.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "music",
                                  },
                                },
                                [_c("icon-music")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Gestion de la Musique\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized(["admin", "developer"])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: { to: { name: "Connector" }, tag: "b-card" },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box":
                                      _vm.IconConnector.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "connector",
                                  },
                                },
                                [_c("icon-connector")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Connecteur NETSOINS\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized(["admin", "developer"])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: {
                            to: { name: "ConnectorTiti" },
                            tag: "b-card",
                          },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box":
                                      _vm.IconConnector.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "connector",
                                  },
                                },
                                [_c("icon-connector")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Connecteur TITAN\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c(
            "b-card-group",
            { attrs: { deck: "" } },
            [
              _c(
                "b-card",
                { attrs: { header: "Statistiques", "header-tag": "header" } },
                [
                  _c(
                    "b-card-group",
                    { staticClass: "home-card", attrs: { deck: "" } },
                    [
                      _c(
                        "router-link",
                        {
                          class: _vm.isAuthorized([
                            "admin",
                            "trainer",
                            "seller",
                          ])
                            ? "classicLink"
                            : "disabledLink",
                          attrs: { to: { name: "Export" }, tag: "b-card" },
                        },
                        [
                          _c(
                            "b-card-text",
                            { staticClass: "card-icon" },
                            [
                              _c(
                                "icon-base",
                                {
                                  attrs: {
                                    "view-box":
                                      _vm.IconXlsExport.data().viewBox,
                                    width: "50",
                                    height: "50",
                                    "icon-name": "xls-export",
                                  },
                                },
                                [_c("icon-xls-export")],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-card-text", [
                            _vm._v(
                              "\n              Exports Excel\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }